import React from 'react';
import type { Stamp } from '../hooks/useStamps';
import DraggableStamp from './DraggableStamp';

interface StampOverlayProps {
    stamps: Stamp[];
    containerRef: React.RefObject<HTMLDivElement | null>;
    onUpdate: (id: string, partial: Partial<Omit<Stamp, 'id' | 'type'>>) => void;
    onRemove: (id: string) => void;
    onRequestEyedropper?: (callback: (color: string) => void) => void;
    /** 自訂 z-index；用於分層渲染（畫筆前 vs 畫筆後） */
    zIndex?: number;
    /** stamp 編輯 popover 展開方向 */
    popoverPlacement?: 'left' | 'right';
}

const StampOverlay: React.FC<StampOverlayProps> = ({ stamps, containerRef, onUpdate, onRemove, onRequestEyedropper, zIndex = 10, popoverPlacement = 'left' }) => {
    if (stamps.length === 0) return null;

    return (
        <div className="absolute inset-0 pointer-events-none" style={{ zIndex }}>
            {stamps.map(stamp => (
                <DraggableStamp
                    key={stamp.id}
                    stamp={stamp}
                    containerRef={containerRef}
                    onUpdate={onUpdate}
                    onRemove={onRemove}
                    onRequestEyedropper={onRequestEyedropper}
                    popoverPlacement={popoverPlacement}
                />
            ))}
        </div>
    );
};

export default StampOverlay;
